import 'angular';

import addDirective from './add';

const MODULE_NAME = 'daupler.incidents.components.buttons.forms';

var app = angular.module(MODULE_NAME, []);
app.directive('addForm', addDirective);

export default MODULE_NAME;
